import React from 'react';

import CustomizedTabs from '../../Tabs/Tabs';
import DescriptionItem from './DescriptionItem';

const DetailedDescription = props => {
  const {
    description_full,
    instructions,
    specifications,
    reviews
  } = props.goodData;
  const { t } = props;
  const data = [];

  if (description_full) {
    data.push({
      title: t['Описание'],
      content: <DescriptionItem content={description_full} />,
      id: 'description-tab-catalog'
    });
  }
  if (specifications) {
    data.push({
      title: t['Характеристики'],
      content: <DescriptionItem content={specifications} />,
      id: 'characteristic-tab-catalog'
    });
  }
  if (instructions) {
    data.push({
      title: t['инструкция'],
      content: <DescriptionItem content={instructions} />,
      id: 'instructions-tab-catalog'
    });
  }
  if (reviews) {
    data.push({
      title: t['Отзывы'],
      content: <DescriptionItem content={reviews} />,
      id: 'reviews-tab-catalog'
    });
  }

  if (!data.length) return null;

  return <CustomizedTabs name="tabpanel-2" data={data} />;
};

export default DetailedDescription;
